module.exports = __webpack_public_path__ + "img/logo.db764f39.svg";